export default {
  name: 'Play3dIcon',
  props: {
    width: {
      type: Number,
      default: 17
    },
    height: {
      type: Number,
      default: 17
    },
    color: {
      type: String,
      default: '#22863D'
    }
  }
};